import { useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import type { Group } from 'three'

/** Dark silhouette chair cue behind person mid-lower band */
export function VirtualChair() {
  const group = useRef<Group>(null)

  useFrame((state) => {
    if (!group.current) return
    group.current.position.y =
      -1.35 + Math.sin(state.clock.elapsedTime * 0.5) * 0.01
  })

  return (
    <group ref={group} position={[0, -1.35, 1.2]} scale={0.85}>
      <mesh position={[0, 0.45, 0]}>
        <boxGeometry args={[0.9, 0.08, 0.85]} />
        <meshStandardMaterial
          color="#0a0a0c"
          metalness={0.2}
          roughness={0.85}
          transparent
          opacity={0.72}
        />
      </mesh>
      <mesh position={[0, 0.95, -0.38]}>
        <boxGeometry args={[0.9, 1.0, 0.08]} />
        <meshStandardMaterial
          color="#0a0a0c"
          metalness={0.2}
          roughness={0.85}
          transparent
          opacity={0.72}
        />
      </mesh>
      {[
        [-0.38, 0.2, 0.35],
        [0.38, 0.2, 0.35],
        [-0.38, 0.2, -0.35],
        [0.38, 0.2, -0.35],
      ].map((p, i) => (
        <mesh key={i} position={p as [number, number, number]}>
          <cylinderGeometry args={[0.03, 0.04, 0.45, 8]} />
          <meshStandardMaterial
            color="#0a0a0c"
            metalness={0.2}
            roughness={0.85}
            transparent
            opacity={0.72}
          />
        </mesh>
      ))}
    </group>
  )
}
